const footerData = [
    {
        id: 1,
        url: '#',
        title: 'MEN',
        key: 'shop',
    },
    {
        id: 2,
        url: '#',
        title: 'WOMEN',
        key: 'shop',
    },
    {
        id: 3,
        url: '#',
        title: 'KIDS',
        key: 'shop',
    },
    {
        id: 4,
        url: '#',
        title: 'New Arrivals',
        key: 'shop',
    },
    {
        id: 5,
        url: '#',
        title: 'Contact Us',
        key: 'shed',
    },
    {
        id: 6,
        url: '#',
        title: 'Cancellation',
        key: 'shed',
    },
    {
        id: 7,
        url: '#',
        title: 'Returns',
        key: 'shed',
    },
    {
        id: 8,
        url: '#',
        title: 'FAQ',
        key: 'shed',
    },
    {
        id: 9,
        url: '#',
        title: 'Press',
        key: 'companyRelated',
    },
    {
        id: 19,
        url: '#',
        title: 'Fanbook',
        key: 'companyRelated',
    },
    {
        id: 11,
        url: '#',
        title: 'Careers',
        key: 'companyRelated',
    },
    {
        id: 12,
        url: '#',
        title: 'Jobs',
        key: 'companyRelated',
    },
]

export { footerData }